import React, { useEffect, useState } from 'react';
import axios from 'axios';

const PREFIX = '__JEI_SERVICE__:';
const emptyForm = { title: '', description: '', advantages: '', order: 1 };
const initialServices = [
  { title: 'Développement Web Front-End', description: 'Notre équipe maîtrise React et Next.js pour concevoir des interfaces web modernes, accessibles et performantes, adaptées à vos utilisateurs comme à vos objectifs métier.', advantages: ['Rapidité de développement', 'Optimisation du référencement SEO', 'Meilleure performance'], order: 1 },
  { title: 'Développement Web Back-End', description: 'Notre équipe conçoit avec NestJS et Express des API robustes, sécurisées et évolutives, capables de soutenir durablement vos applications et leurs intégrations.', advantages: ['Intégration simplifiée', 'Architecture modulaire', 'Performance optimisée'], order: 2 },
  { title: 'Développement Mobile', description: 'Notre équipe utilise Flutter pour créer des applications mobiles fluides et performantes, avec une expérience cohérente sur Android et iOS.', advantages: ['Rapidité de développement', 'Expérience utilisateur remarquable', 'Personnalisation et évolutivité'], order: 3 },
  { title: 'Intelligence Artificielle', description: 'Nous intégrons des solutions d’intelligence artificielle adaptées à vos processus pour automatiser, analyser et créer des expériences numériques plus intelligentes.', advantages: ['Automatisation ciblée', 'Analyse de données', 'Solutions adaptées à vos usages'], order: 4 },
];
const headers = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

function decode(item) {
  if (!item.question?.startsWith(PREFIX) || item.deletedAt) return null;
  try {
    const value = JSON.parse(item.answer || '{}');
    return { id: item.id, title: value.title || item.question.slice(PREFIX.length), description: value.description || '', advantages: (value.advantages || []).join('\n'), order: Number(value.order) || 1 };
  } catch { return null; }
}

export default function ServiceManagement() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState(emptyForm);
  const [editingId, setEditingId] = useState(null);
  const [error, setError] = useState('');

  const load = async () => {
    try {
      const { data } = await axios.get('/faq');
      let services = data.map(decode).filter(Boolean);
      if (services.length === 0) {
        await Promise.all(initialServices.map((service) => axios.post('/faq', {
          question: `${PREFIX}${service.title}`,
          answer: JSON.stringify(service),
        }, { headers: headers() })));
        const seeded = await axios.get('/faq');
        services = seeded.data.map(decode).filter(Boolean);
      }
      setItems(services.sort((a, b) => a.order - b.order));
    } catch { setError('Impossible de charger les services.'); }
  };
  useEffect(() => { load(); }, []);

  const save = async (event) => {
    event.preventDefault(); setError('');
    const payload = {
      question: `${PREFIX}${form.title.trim()}`,
      answer: JSON.stringify({ title: form.title.trim(), description: form.description.trim(), advantages: form.advantages.split('\n').map((x) => x.trim()).filter(Boolean), order: Number(form.order) }),
    };
    try {
      if (editingId) await axios.patch(`/faq/${editingId}`, payload, { headers: headers() });
      else await axios.post('/faq', payload, { headers: headers() });
      setForm(emptyForm); setEditingId(null); await load();
    } catch (requestError) { setError(requestError.response?.data?.message || 'Impossible d’enregistrer le service.'); }
  };

  const edit = (item) => { setEditingId(item.id); setForm({ title: item.title, description: item.description, advantages: item.advantages, order: item.order }); window.scrollTo({ top: 0, behavior: 'smooth' }); };
  const remove = async (id) => { if (!window.confirm('Supprimer ce service ?')) return; await axios.delete(`/faq/${id}`, { headers: headers() }); await load(); };

  return <div className="dashboard-container">
    <div className="top-bar"><h3>Services du site</h3></div>
    <p>Les modifications apparaissent sur jeinsat.com sous cinq minutes, sans chargement du CMS dans le navigateur du visiteur.</p>
    {error && <p style={{ color: 'red' }}>{String(error)}</p>}
    <div className="form-card" style={{ marginBottom: 30 }}><form onSubmit={save} className="project-form">
      <h3>{editingId ? 'Modifier le service' : 'Nouveau service'}</h3>
      <div className="form-group"><label className="form-label">Titre *</label><input className="form-input" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} required /></div>
      <div className="form-group"><label className="form-label">Description *</label><textarea className="form-input" rows="5" value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} required /></div>
      <div className="form-group"><label className="form-label">Avantages (un par ligne)</label><textarea className="form-input" rows="5" value={form.advantages} onChange={(e) => setForm({ ...form, advantages: e.target.value })} /></div>
      <div className="form-group"><label className="form-label">Ordre</label><input className="form-input" type="number" min="1" value={form.order} onChange={(e) => setForm({ ...form, order: e.target.value })} /></div>
      <button className="btn-save" type="submit">{editingId ? 'Enregistrer' : 'Ajouter'}</button>
      {editingId && <button type="button" className="icon-button" onClick={() => { setEditingId(null); setForm(emptyForm); }}>Annuler</button>}
    </form></div>
    <table className="partners-table"><thead><tr><th>Ordre</th><th>Service</th><th>Description</th><th>Actions</th></tr></thead><tbody>{items.map((item) => <tr key={item.id}><td>{item.order}</td><td>{item.title}</td><td>{item.description}</td><td><button className="icon-button" onClick={() => edit(item)}>Modifier</button> <button className="icon-button text-red-600" onClick={() => remove(item.id)}>Supprimer</button></td></tr>)}</tbody></table>
  </div>;
}
